import { render, staticRenderFns } from "./medical_table.vue?vue&type=template&id=1b568cc7&scoped=true"
import script from "./medical_table.vue?vue&type=script&lang=js"
export * from "./medical_table.vue?vue&type=script&lang=js"
import style0 from "./medical_table.vue?vue&type=style&index=0&id=1b568cc7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b568cc7",
  null
  
)

export default component.exports